import { ParamsHeader, HelperSubtitle, Subtitle } from "../styles/styles";

export const TabHeader = ({ title = "", subtitle = "" }) => (
  <ParamsHeader>
    <HelperSubtitle variant="h6">{title}</HelperSubtitle>
    {subtitle && <Subtitle>{subtitle}</Subtitle>}
  </ParamsHeader>
);
